<template>
    <div id="app">
        <div class="header w-full p-6 text-center">
            <img
                alt="Yamaha"
                class="m-auto max-w-md"
                src="./assets/logo-revs-negro-197x69.png"
                srcset="./assets/logo-revs-negro-394x137.png 2x"
            />
        </div>

        <div class="m-auto max-w-5xl w-full shadow-lg print:shadow-none">
            <div
                class="header-app w-full h-48 flex bg-cover bg-white text-center overflow-hidden print:hidden"
                title="Agendamiento"
            >
                <div
                    class="w-full flex flex-wrap p-4 content-center justify-start"
                >
                    <div
                        class="w-full yamaha-title text-center md:text-left text-2xl text-white"
                    >
                        Agendamiento Servicio Técnico
                    </div>
                    <!--div
                        class="w-full text-sm text-center md:text-left text-white"
                    >
                        Disponible sólo en Casa Matriz Yamaha Las Condes
                    </div-->
                </div>
            </div>

            <div
                id="app-content"
                v-cloak
                class="relative border-gray-100 bg-white p-4 flex flex-col justify-between leading-normal print:border-none"
            >
                <navbar />

                <router-view />

                <ui-loader />
            </div>
        </div>

        <p class="text-center text-gray text-xs mt-8">
            ©{{ anio }} YamaImport. Todos los derechos reservados.
        </p>
    </div>
</template>
<script>
import UiLoader from "./components/UiLoader";
import Navbar from "./components/Navbar";

export default {
    components: { Navbar, UiLoader },
    computed: {
        anio: () => new Date().getFullYear()
    }
};
</script>
<style>
.header-app {
    background-image: url("assets/header_agendamiento_v2.jpg");
}
</style>
